module.exports = __webpack_public_path__ + "static/c10-4175bcad37e4886b872a669021cadab9.jpg";